import * as Sentry from '@sentry/browser';
import { Integrations } from "@sentry/tracing";

const env: any = {};
switch (window.location.hostname) {
  case 'static.test.xiaopeng.local':
    env.network = 'test';
    break;
  case 'static.deploy-test.xiaopeng.com':
    env.network = 'preview';
    break;
  case 'static.xiaopeng.com':
    env.network = 'production';
    break;
  default:
    env.network = null;
    break;
}
let environment = 'dev';
if (env.network === 'test') {
  environment = 'test';
} else if (env.network === 'preview') {
  environment = 'preview';
} else if (env.network === 'production') {
  environment = 'production';
}
const version = 'charge-web@' + require('../../package.json').version;
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const SentryRun = (devNeed = false) => {
  if (!devNeed && environment === 'dev') {
    return;
  }
  Sentry.init({
    dsn:
      'https://56b8109bcb654b02abb091ee2cc9402f@front-monitor.xiaopeng.com/50',
    // 初始参数配置内容
    integrations: [new Integrations.BrowserTracing()],
    environment: environment,
    release: version,
    debug: environment === 'dev',
    // 触发异常后发送给 Sentry 的概率
    tracesSampleRate: 1.0,
  });

  Sentry.setTag('UA', /xiaopeng/i.test(navigator?.userAgent || '') ? 'isXpApp' : 'isNotXpApp');
};

export default SentryRun;
